import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const HandwrittenSymptomsImage = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "images/handwritten-symptoms.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 360) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  if (!data?.placeholderImage?.childImageSharp?.fluid) {
    return <div>Picture not found</div>
  }

  return <Img style={{maxWidth: '360px'}} fluid={data.placeholderImage.childImageSharp.fluid} alt={'A list of symptoms, handwritten by a child. Symptoms include being dizzy, having double vision, and having a headache all of the time.'} />
}

export default HandwrittenSymptomsImage
